import { forwardRef } from 'react';
import { Slot, Slottable } from '@radix-ui/react-slot';

import { cn, memoClassNames } from '@/utils';
import { buttonVariants, ButtonVariantProps } from './variants';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    ButtonVariantProps {
  asChild?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  helpText?: string;
}

const classes = memoClassNames('Button', ['root']);
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      // variant,
      size,
      asChild = false,
      children,
      startIcon,
      variant,
      endIcon,
      helpText,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        className={cn(
          classes.root,
          buttonVariants({
            variant,
            size,
            className,
          })
        )}
        data-size={size}
        data-variant={variant}
        ref={ref}
        title={helpText}
        {...props}
      >
        {startIcon}

        <Slottable>{children}</Slottable>

        {endIcon}
      </Comp>
    );
  }
);

Button.displayName = 'Button';
